import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "root-search" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_text_field = _resolveComponent("v-text-field");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_text_field, {
            modelValue: _ctx.query,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query) = $event)),
            variant: "outlined",
            "hide-details": "",
            density: "compact",
            placeholder: _ctx.placeholder,
            "bg-color": "white",
            "append-inner-icon": _ctx.appendIcon,
            onKeyup: _cache[1] || (_cache[1] = ($event) => ($event.stopPropagation())),
            "onClick:appendInner": _ctx.handleClickClose
        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "append-inner-icon", "onClick:appendInner"])
    ]));
}
